import produce from "immer";
import {OperationErrorType, StoreAction} from "orpyx-web-common";
import {IPatientStatusType} from "admins-dashboard/http-clients/index";
import {PatientStatusTypesActions} from "./patient-status-types-actions";

export interface PatientStatusTypesState {
    initialized: boolean;
    statusTypes: IPatientStatusType[];
    error?: OperationErrorType;
}

const initialState: PatientStatusTypesState = {
    initialized: false,
    statusTypes: []
};

const PatientStatusTypesReducers = (state = initialState, action: StoreAction<PatientStatusTypesActions>): PatientStatusTypesState => {
    return produce(state, (draft: PatientStatusTypesState) => {
        switch (action.type) {
            case PatientStatusTypesActions.INITIALIZE:
                draft.initialized = false;
                draft.error = undefined;
                break;

            case PatientStatusTypesActions.INITIALIZE_SUCCESSFULLY:
                draft.initialized = true;
                draft.statusTypes = action.payload;
                draft.error = undefined;
                break;

            case PatientStatusTypesActions.INITIALIZE_FAILED:
                draft.initialized = false;
                draft.error = action.payload;
                draft.statusTypes = [];
                break;
        }
    })
};

export default PatientStatusTypesReducers;
